/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HideForFuture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function HideForFuture({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardCreate/HideForFuture",
  onChange,
  isSubmitting
  
}) {
let txCardFieldDefinitionHideForFutureValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'hide_for_future',
})
let txCardFieldDefinitionHideForFutureChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'hide_for_future',
})
let txCardFieldDefinitionHideForFutureIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Hide for future"
 data="tx_card_field_definition.hide_for_future"
 value={txCardFieldDefinitionHideForFutureValueData}
 onChange={txCardFieldDefinitionHideForFutureChangeData}
 disabled={txCardFieldDefinitionHideForFutureIsSubmittingData}
/>
{children}
</React.Fragment>)
}